import logitravelSearcherStyles from "./styles/logitravel.js";
import partnershipsSearcherStyles from "./styles/partnerships.js";
import partnershipsUniversalMusicSearcherStyles from "./styles/partnershipsUniversalMusic.js";
import smySearcherStyles from "./styles/smy.js";
import veciSearcherStyles from "./styles/veci.js";
const searcherThemes = {
    logitravel: logitravelSearcherStyles,
    partnerships: partnershipsSearcherStyles,
    partnershipsUniversalMusic: partnershipsUniversalMusicSearcherStyles,
    smy: smySearcherStyles,
    veci: veciSearcherStyles
};
export default searcherThemes;

//# sourceMappingURL=index.js.map